import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    webInfo: {
      list: []
    },
    message: {
      list: []
    },
    contentTemplate: {
      list: []
    },
    admin: {
      Profile: {
        Name: ''
      }
    },
    post: {
      list: [],
      tagList: [],
      isFetched: false,
      isFetching: false
    },
    work: {
      list: [],
      isFetched: false,
      isFetching: false
    }
  },
  getters: {
    profile: state => {
      return state.profile
    }
  },
  mutations: {
  },
  actions: {

  }
})
